import { render, staticRenderFns } from "./SlackIcon.vue?vue&type=template&id=176bec05&scoped=true"
import script from "./SlackIcon.vue?vue&type=script&lang=js"
export * from "./SlackIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176bec05",
  null
  
)

export default component.exports